import { createStyles } from '@mantine/core';

export const MODAL_ICON_SIZE = 60;

export const useStyles = createStyles((theme) => ({
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.other.spacing._16,
  },
  modalIcon: {
    position: 'relative',
    width: MODAL_ICON_SIZE,
    height: MODAL_ICON_SIZE,
  },
  modalIconImage: {
    objectFit: 'contain',
  },
  modalTitle: {
    maxWidth: 370,
    textAlign: 'center',
  },
  modalTag: {
    display: 'block',
    width: 'fit-content',
    margin: `${theme.other.spacing._4}px auto 0 auto`,
    textTransform: 'uppercase',
    backgroundColor: theme.colors.blue[3],
    padding: `${theme.other.spacing._2}px ${theme.other.spacing._6}px`,
    borderRadius: theme.other.spacing._12,
  },
  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.other.spacing._16,
    maxWidth: 490,
    marginTop: theme.other.spacing._24,
  },

  modalSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.other.spacing._16,
    width: '100%',

    '& + &': {
      borderTop: `1px solid ${theme.colors.gray2[0]}`,
      paddingTop: theme.other.spacing._16,
    },
  },
  modalSectionBullet: {
    width: theme.other.spacing._24,
    height: theme.other.spacing._24,
    borderRadius: '50%',
    backgroundColor: theme.colors.blue[1],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  modalSectionContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.other.spacing._4,
  },
  modalSectionText: {
    textAlign: 'left',
  },
  modalNote: {
    textAlign: 'left',
    width: '100%',
    padding: theme.other.spacing._12,
    borderRadius: theme.radius.md,
    backgroundColor: theme.colors.gray2[0],
  },
}));
